import useStrings from "../../../localization/useStrings"
import images from "../../../utils/images"
import { useFreeTrialPaywall } from "../freeTrialPaywallContext"
import styles from "./FreeTrialPaywallTimeline.module.scss"

interface TimelineItem {
  title: string
  subtitle: string
  imageClass: string
  dashColor: string
  onClick?: () => void
  minHeight: number
}

const FreeTrialPaywallTimeline = () => {
  const { actions } = useFreeTrialPaywall()
  const strings = useStrings().freeTrialPaywall

  const items: TimelineItem[] = [
    {
      title: strings.firstStep.title,
      subtitle: strings.firstStep.subtitle,
      imageClass: images.freeTrial.trialStep1.class,
      dashColor: "#D79A65",
      minHeight: 120,
    },
    {
      title: strings.secondStep.title,
      subtitle: strings.secondStep.subtitle,
      imageClass: images.freeTrial.trialStep2.class,
      dashColor: "#AAAAAA",
      onClick: () => {
        actions.setShowFeaturesSheet(true)
      },
      minHeight: 120,
    },
    {
      title: strings.thirdStep.title,
      subtitle: strings.thirdStep.subtitle,
      imageClass: images.freeTrial.trialStep3.class,
      dashColor: "transparent",
      minHeight: 60,
    },
  ]

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.timeline}>
        {items.map((item, index) => (
          <PaywallItem item={item} key={index}></PaywallItem>
        ))}
        <div className={styles.background}></div>
      </div>
    </div>
  )
}

interface PaywallItemProps {
  item: TimelineItem
}

const PaywallItem = ({ item }: PaywallItemProps) => {
  const style = {
    borderLeft: `3px dashed ${item.dashColor}`,
  }

  const showButton = item.onClick != null
  const strings = useStrings().freeTrialPaywall

  return (
    <div className={styles.itemContainer} style={{ minHeight: item.minHeight }}>
      <div className={styles.itemLeft}>
        <div className={`${item.imageClass} ${styles.itemImage}`} />
        <div className={styles.itemLineContainer}>
          <div className={styles.itemLine} style={style}></div>
        </div>
      </div>
      <div className={styles.textContainer}>
        <label className={styles.title}>{item.title}</label>
        <label className={styles.subtitle}>{item.subtitle}</label>
        {showButton && (
          <button className={styles.itemButton} onClick={item.onClick}>
            {strings.whatsIncluded}
          </button>
        )}
      </div>
    </div>
  )
}

export default FreeTrialPaywallTimeline
